import { reactive, computed } from "vue"
import { parseJSON } from "date-fns"
import { post_csrf } from "../utils/csrf"
import mixChannelSubscription from "./mix_channel_subscription"

function fromAPI(note, songID) {
  note.created_at = parseJSON(note.created_at)
  note.isLike = (note.note == ":like:")

  if (songID) note.song_id = songID

  return note
}

export function buildNote(attributes) {
  return Object.assign(
    {},
    {
      id: new Date().toISOString(),
      unsaved: true,
      created_at: new Date(),
      username: mmmGlobals.username,
      note: "",
    },
    attributes || {}
  )
}

const dataStore = reactive({
  notes: {},
  songFetch: {},
})

const store = reactive({
  ...dataStore,
  songNotes: computed(() => {
    const map = {}
    for (const note of Object.values(dataStore.notes)) {
      const songID = note.song_id
      if (!map[songID]) {
        map[songID] = []
      }
      map[songID].push(note)
    }
    return map
  }),
  replies: computed(() => {
    const map = {}
    Object.values(dataStore.notes)
      .filter(n => n.parent_note_id && !n.deleted && !n.isLike)
      .forEach(n => {
        if (!map[n.parent_note_id]) {
          map[n.parent_note_id] = []
        }
        map[n.parent_note_id].push(n)
      })

    return map
  }),
  likes: computed(() => {
    const map = {}
    Object.values(dataStore.notes)
      .filter(n => n.parent_note_id && !n.deleted && n.isLike)
      .forEach(n => {
        if (!map[n.parent_note_id]) {
          map[n.parent_note_id] = []
        }
        map[n.parent_note_id].push(n)
      })

    return map
  }),
  async fetchNotes(songID) {
    const obj = this.songFetch[songID]
    if (obj instanceof Promise) {
      return await obj
    } else if (obj == true) {
      return this.songNotes[songID]
    }

    const promise = fetch(`/notes.json?song_id=${songID}`)
    this.songFetch[songID] = promise

    const r = await promise
    if (r.status != 200) {
      throw new Error("Couldn't fetch song notes!")
    }

    const json = await r.json()
    json["notes"].forEach(n => (this.notes[n.id] = fromAPI(n, songID)))
    this.songFetch[songID] = true

    // Subscribe to real-time updates when notes are first fetched
    this.subscribeToNotesChannel()

    return this.songNotes[songID]
  },
  async createNote(note) {
    if (!mmmGlobals.logged_in) {
      note.anonymous_name = window.localStorage.username
    }

    const res = await post_csrf("/notes.json", { note: note }, { method: "POST" })

    if (res.status != 200) {
      console.log("error updating note", await res.json())
      return
    }

    const json = await res.json()
    const n = fromAPI(json.note)

    delete dataStore.notes[note.id]
    n.baseColor = note.baseColor
    n.highlightColor = note.highlightColor

    this.notes[n.id] = n
  },
  async updateNote(id, attributes) {
    let note = this.notes[id]

    // prevent flickering
    if (attributes.completed) note.baseColor = note.highlightColor

    if (!mmmGlobals.logged_in) {
      note.anonymous_name = window.localStorage.username
    }

    const res = await post_csrf(`/notes/${id}.json`, { note: attributes }, { method: "PUT" })

    if (res.status != 200) {
      console.error("error updating note", res)
      return
    }

    const json = await res.json()
    const n = fromAPI(json.note)

    // reuse old note so as to keep colors & such
    Object.assign(note, n)

    //if (n.completed) {
    // n.replies.forEach(r => r.completed = true)
    //}
  },
  async deleteNote(id) {
    const note = this.notes[id]

    if (note.unsaved) {
      delete this.notes[id]
      return
    }

    await post_csrf(`/notes/${id}.json`, {}, { method: "delete" })
    delete this.notes[id]
  },
  replyTo(note) {
    const reply = buildNote({ parent_note_id: note.id, mix_id: note.mix_id, song_id: note.song_id })
    this.notes[reply.id] = reply
  },
  subscribeToNotesChannel() {
    // Register our callback with the shared mix channel subscription for 'note' type
    mixChannelSubscription.registerCallback('note', (data) => {
      const note = fromAPI(data.note, data.note.song_id)

      const existingNote = dataStore.notes[note.id]

      if (existingNote) {
        // Update existing note, preserving note colors
        const colors = {
          baseColor: existingNote.baseColor,
          highlightColor: existingNote.highlightColor
        }
        Object.assign(existingNote, note, colors)
      } else {
        dataStore.notes[note.id] = note
      }
    })
  }
})

export default store
